export default __webpack_public_path__ + "static/media/Screen Shot 2021-10-26 at 10.43.44 PM.70bec491.png";